export default __webpack_public_path__ + "static/media/rotate.402c18a5.svg";